// #region Type
export const ACTION_TYPE = {
  CALL_API_INIT_MAIL_TEMPLATE_LIST: 'CALL_API_INIT_MAIL_TEMPLATE_LIST',
  CALL_API_INIT_MAIL_TEMPLATE_LIST_SUCCESS: 'CALL_API_INIT_MAIL_TEMPLATE_LIST_SUCCESS',
  CALL_API_MAIL_TEMPLATE_LIST: 'CALL_API_MAIL_TEMPLATE_LIST',
  CALL_API_MAIL_TEMPLATE_LIST_SUCCESS: 'CALL_API_MAIL_TEMPLATE_LIST_SUCCESS',
  SET_SEARCH_MAIL_TEMPLATES: 'SET_SEARCH_MAIL_TEMPLATES',
  CALL_API_DELETE_MAIL_TEMPLATE: 'CALL_API_DELETE_MAIL_TEMPLATE',
  CALL_API_DELETE_MAIL_TEMPLATE_SUCCESS: 'CALL_API_DELETE_MAIL_TEMPLATE_SUCCESS',
  RESET_MAIL_TEMPLATE_FLG: 'RESET_MAIL_TEMPLATE_FLG',
  CALL_API_GET_MAIL_TEMPLATE: 'CALL_API_GET_MAIL_TEMPLATE',
  CALL_API_GET_MAIL_TEMPLATE_SUCCESS: 'CALL_API_GET_MAIL_TEMPLATE_SUCCESS',
  CALL_API_SAVE_MAIL_TEMPLATE: 'CALL_API_SAVE_MAIL_TEMPLATE',
  CALL_API_SAVE_MAIL_TEMPLATE_SUCCESS: 'CALL_API_SAVE_MAIL_TEMPLATE_SUCCESS',
};
// #endregion

// #region Type
export const actCallInitMailTemplateList = () => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_TEMPLATE_LIST,
});

export const actInitMailTemplateListSuccess = (selects) => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_TEMPLATE_LIST_SUCCESS,
  selects,
});

export const actCallApiMailTemplateList = (searchCondition) => ({
  type: ACTION_TYPE.CALL_API_MAIL_TEMPLATE_LIST,
  searchCondition,
});

export const actCallApiMailTemplateListSuccess = (datas) => ({
  type: ACTION_TYPE.CALL_API_MAIL_TEMPLATE_LIST_SUCCESS,
  datas,
});

export const actSetSearchCondition = (searchCondition) => ({
  type: ACTION_TYPE.SET_SEARCH_MAIL_TEMPLATES,
  searchCondition,
});

export const actCallApiDeleteMailTemplate = (deleteList) => ({
  type: ACTION_TYPE.CALL_API_DELETE_MAIL_TEMPLATE,
  deleteList,
});

export const actCallApiDeleteMailTemplateSuccess = () => ({
  type: ACTION_TYPE.CALL_API_DELETE_MAIL_TEMPLATE_SUCCESS,
  isDeleteSuccess: true,
});

export const actCallApiGetMailTemplate = (param) => ({
  type: ACTION_TYPE.CALL_API_GET_MAIL_TEMPLATE,
  param,
});

export const actCallApiGetMailTemplateSuccess = (data) => ({
  type: ACTION_TYPE.CALL_API_GET_MAIL_TEMPLATE_SUCCESS,
  data,
});

export const actCallApiSaveMailTemplate = (data) => ({
  type: ACTION_TYPE.CALL_API_SAVE_MAIL_TEMPLATE,
  data,
});

export const actCallApiSaveMailTemplateSuccess = (saveId) => ({
  type: ACTION_TYPE.CALL_API_SAVE_MAIL_TEMPLATE_SUCCESS,
  saveId,
});

export const actResetMailTemplateFlg = () => ({
  type: ACTION_TYPE.RESET_MAIL_TEMPLATE_FLG,
});
